export var BADGE_CLASS_PREFIX = 'Badge';